<template>
  <div
    class="netpa-tab"
    :style="{ marginBottom: '-' + Gap + 'px' }"
    dir="rtl"
  >
    <!-- شکل تب فعال: پس‌زمینه‌ی هدر NetPaCard را کپی می‌کند تا به کارت بچسبد -->
    <div
      v-if="Shape"
      class="netpa-tab__shape"
      :style="Shape.box"
      aria-hidden="true"
    >
      <div class="netpa-tab__fill" :style="Shape.fill"></div>
    </div>
    <ul class="nav netpa-tab__list" role="tablist">
      <li v-for="(tab, index) in Tabs" :key="tab.id" class="netpa-tab__item">
        <a
          class="netpa-tab__link"
          :class="IsActive(tab, index) ? 'active' : ''"
          :id="tab.id + '-tab'"
          data-toggle="tab"
          :href="'#' + tab.id"
          role="tab"
          :aria-controls="tab.id"
          :aria-selected="IsActive(tab, index) ? 'true' : 'false'"
          >{{ tab.title }}</a
        >
      </li>
    </ul>
    <div class="netpa-tab__actions"><slot></slot></div>
  </div>
</template>
<script>
/*
  استفاده:
  <net-pa-tab :Tabs="[{ id: 'nav-home', title: 'عنوان' }]" @change="id => ...">
    دکمه‌های کنار تب‌ها (اختیاری)
  </net-pa-tab>
  رویداد change بعد از هر تغییر تب، id پنل فعال را می‌دهد
  <net-pa-card> ... </net-pa-card>   <- حتماً بلافاصله بعد از تب
  یا یک <div class="tab-content"> که اولین عنصر هر پنل آن یک net-pa-card است
  اگر عنوان کارت با عنوان تب تکراری است، هدر کارت را فشرده و بدون عنوان بسازید
  (گرادیان هدر می‌ماند و خود تب نقش عنوان را دارد):
  <net-pa-card :Compact="true"> ... </net-pa-card>

  پنل‌ها همان tab-pane بوت‌استرپ هستند و id آن‌ها باید با id تب برابر باشد:
  <div class="tab-content">
    <div class="tab-pane fade show active" id="nav-home">...</div>
  </div>
*/
export default {
  name: "NetPaTab",
  data() {
    return {
      Shape: null,
      Gap: 8,
    };
  },
  // Active (اختیاری): id تبی که در شروع فعال است؛ پیش‌فرض اولین تب
  props: ["Tabs", "Radius", "Active"],
  computed: {
    R() {
      return this.Radius ? Number(this.Radius) : 14;
    },
  },
  watch: {
    Tabs() {
      this.$nextTick(this.Sync);
    },
  },
  methods: {
    IsActive(tab, index) {
      return this.Active ? tab.id == this.Active : index == 0;
    },
    // با شروع تغییر تب (مثل کلیک): id پنل جدید را emit می‌کند
    OnShow(e) {
      const href = e && e.target ? e.target.getAttribute("href") : "";
      this.$emit("change", href ? href.replace("#", "") : "");
    },
    // کارتی که تب به آن می‌چسبد:
    // یا خود عنصر بعدی است، یا اولین کارت پنل فعال داخل tab-content
    GetCard() {
      const next = this.$el.nextElementSibling;
      if (!next) return null;
      if (next.classList.contains("netpa-card")) return next;
      return (
        next.querySelector(".tab-pane.active .netpa-card") ||
        next.querySelector(".netpa-card")
      );
    },
    GetHeader() {
      const card = this.GetCard();
      return card ? card.querySelector(".netpa-card__header") : null;
    },
    Sync() {
      const card = this.GetCard();
      const header = this.GetHeader();
      const active = this.$el.querySelector(".netpa-tab__link.active");
      if (!card || !header || !active) return;
      // کارت بالا نپرد تا درز تب و کارت باز نشود
      card.style.transform = "none";
      this.Gap = parseFloat(getComputedStyle(card).marginTop) || 0;

      const r = this.R;
      const root = this.$el.getBoundingClientRect();
      const tab = active.getBoundingClientRect();
      const head = header.getBoundingClientRect();
      const left = tab.left - root.left - r;
      const w = tab.width + r * 2;
      // یک پیکسل روی border بالای کارت می‌نشیند
      const h = tab.height + 1;
      const shape = {
        box: {
          left: left + "px",
          top: tab.top - root.top + "px",
          width: w + "px",
          height: h + "px",
        },
        fill: {
          backgroundImage: getComputedStyle(header).backgroundImage,
          // هدر فشرده (Compact) از تب کوتاه‌تر است؛ گرادیان باید کل تب را بپوشاند
          backgroundSize:
            header.clientWidth + "px " + Math.max(header.clientHeight, h) + "px",
          backgroundPosition: head.left - (root.left + left) + "px 0",
          clipPath:
            "path('M0 " + h +
            " A" + r + " " + r + " 0 0 0 " + r + " " + (h - r) +
            " L" + r + " " + r +
            " A" + r + " " + r + " 0 0 1 " + r * 2 + " 0" +
            " L" + (w - r * 2) + " 0" +
            " A" + r + " " + r + " 0 0 1 " + (w - r) + " " + r +
            " L" + (w - r) + " " + (h - r) +
            " A" + r + " " + r + " 0 0 0 " + w + " " + h + " Z')",
        },
      };
      const key = JSON.stringify(shape);
      if (key === this.LastShape) return;
      this.LastShape = key;
      this.Shape = shape;
    },
  },
  mounted() {
    this.$nextTick(this.Sync);
    window.addEventListener("resize", this.Sync);
    $(this.$el).on("show.bs.tab", this.OnShow);
    $(this.$el).on("shown.bs.tab", this.Sync);
    if (window.ResizeObserver) {
      this.Observer = new ResizeObserver(this.Sync);
      this.Observer.observe(this.$el);
      this.Observer.observe(this.$el.querySelector(".netpa-tab__list"));
      const header = this.GetHeader();
      if (header) this.Observer.observe(header);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.Sync);
    $(this.$el).off("show.bs.tab", this.OnShow);
    $(this.$el).off("shown.bs.tab", this.Sync);
    if (this.Observer) this.Observer.disconnect();
  },
};
</script>
<style scoped>
.netpa-tab {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-border-default: #dbe5eb;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 16px;
  padding: 0 4px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

/* ‌شکل تب فعال؛ خط دور آن با drop-shadow ساخته می‌شود و پایین آن خط ندارد */
.netpa-tab__shape {
  position: absolute;
  z-index: 0;
  pointer-events: none;
  filter: drop-shadow(1px 0 0 var(--bnp-border-default))
    drop-shadow(-1px 0 0 var(--bnp-border-default))
    drop-shadow(0 -1px 0 var(--bnp-border-default));
}

.netpa-tab__fill {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  background-repeat: no-repeat;
}

.nav.netpa-tab__list {
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
  align-items: flex-end;
  margin: 0;
  padding: 0 36px;
  list-style: none;
  border: 0;
}

.netpa-tab__item {
  margin: 0;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  margin: 0;
  padding: 10px 26px;
  color: #5d6d82;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  border-radius: 14px 14px 0 0;
  background: transparent;
  box-shadow: none;
  transition: color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:hover {
  color: var(--bnp-brand-navy);
  background: rgba(41, 52, 95, 0.05);
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active,
.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active:hover,
.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link.active:focus {
  color: var(--bnp-brand-navy);
  font-weight: 800;
  background: transparent;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:focus {
  outline: none;
}

.nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.netpa-tab__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
}

@media (max-width: 767px) {
  .netpa-tab__actions {
    order: -1;
    width: 100%;
    padding-bottom: 0;
  }

  .nav.netpa-tab__list {
    width: 100%;
    padding: 0 32px;
  }

  .netpa-tab__item {
    flex: 1 1 0;
  }

  .nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
    padding: 8px;
    text-align: center;
    white-space: normal;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav.netpa-tab__list > .netpa-tab__item > .netpa-tab__link {
    transition: none;
  }
}
</style>
